export const AddressCodeDialogInitialFocus = {
  AddressCode: '0',
  AreaCode: '1',
  ZipCode: '2',
  AddressName: '3'
}
export type AddressCodeDialogInitialFocus = typeof AddressCodeDialogInitialFocus[keyof typeof AddressCodeDialogInitialFocus]
